import { Star } from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { StyledTooltip } from "Components/UI/StyledTooltip";
import { formatPercentage, percentageOf } from "Helpers/percentage";
import useFormatMetric from "../hooks/useFormatMetric";
import { ApiMetric } from "@incendium/api";

interface ICustomerValueCohortCellProps {
  dimensionName: string;
  valueFormatted: string;
  value: number;
  firstSale: number;
  headerName: string;
  isProfitable: boolean;
}

function CustomerValueCohortCell({
  valueFormatted,
  headerName,
  dimensionName,
  firstSale,
  value,
  isProfitable,
}: ICustomerValueCohortCellProps) {
  const change = percentageOf(value, firstSale);
  const changeValue = value - firstSale;
  const formatMetric = useFormatMetric();
  return (
    <StyledTooltip
      placement={valueFormatted.length > 100 ? "top" : "right"}
      wide
      arrow
      enterDelay={700}
      title={
        <Stack px={2.5}>
          <Typography
            variant="subtitle2"
            color={"primary"}
            mt={0.5}
            gutterBottom
            sx={{ textWrap: "pretty" }}
          >
            {dimensionName}
          </Typography>
          <Divider />
          <Stack alignItems={"center"} mt={1} mb={1.5}>
            <Typography variant={"body1"} color={"inherit"}>
              {headerName} LTV:{" "}
              <Typography component={"b"} color="primary" fontWeight={600}>
                {valueFormatted}
              </Typography>
            </Typography>
            {changeValue === 0 ? (
              <>
                <Typography variant={"body1"} color={"inherit"}>
                  No increase (100% of the first sale)
                </Typography>
              </>
            ) : (
              <>
                <Typography variant={"body1"} color={"inherit"}>
                  Increase of{" "}
                  <Typography component={"b"} color="primary" fontWeight={600}>
                    {formatMetric(ApiMetric.METRIC_LTV_LAST, changeValue, { isKM: true })}
                  </Typography>{" "}
                  ({" "}
                  <Typography component={"b"} color="primary" fontWeight={600}>
                    {formatPercentage(change)}
                  </Typography>{" "}
                  of the first sale)
                </Typography>
              </>
            )}
          </Stack>
        </Stack>
      }
    >
      <Box>
        {isProfitable && (
          <Box sx={{ position: "absolute", top: -10, right: 2 }}>
            <Star fontSize="extraSmall" />
          </Box>
        )}
        <Stack alignItems={"center"}>{valueFormatted}</Stack>
      </Box>
    </StyledTooltip>
  );
}

export default CustomerValueCohortCell;
